window.onMixpanelLoaded(function() {
    var customerEmail = $("#CustomerEmail").val();
    var mixpanelUserId = mixpanel.get_property("$user_id")

    if (customerEmail && customerEmail !== mixpanelUserId) {
        mixpanel.alias(customerEmail);
        mixpanel.identify(customerEmail);
        mixpanel.people.set({ "$email": customerEmail });
    }
})

// Setup basic router
function router() {
    let searchParams = new URLSearchParams(window.location.search);
    if (window.location.hash.substring(1) === "recover") {
        $("#CustomerLoginForm, #RecoverPasswordForm").toggleClass("hidden");
    }
    if (searchParams.has('action')) {
        if (searchParams.get('action') === 'recover') {
            $("#CustomerLoginForm, #RecoverPasswordForm").toggleClass("hidden")
        }
        if (searchParams.get('action') === 'user') {
            $("#customer-fields, #customer_orders").toggleClass("hidden");
        }
        if (searchParams.get('action') === 'edit') {
            $("#Address-list, #Address-edit").toggleClass("hidden");
            $("#EditAddress_" + searchParams.get('id')).toggleClass('hidden');
        }
        if (searchParams.get('action') === 'add') {
            $("#Address-list, #Address-add").toggleClass("hidden");
        }
        if (searchParams.get('action') === 'user') {
            $("#User, #Orders").toggleClass("hidden");
        }
    }
}
window.addEventListener('hashchange', router, false);
router();

$(window).on('hashchange', function () {
    showRestPassword()
});
showRestPassword();

function showRestPassword() {

}

function resetPasswordSuccess() {
    var formState = document.querySelector('.reset-password-success');
    // check if reset password form was successfully submited.
    if (!formState) {
        return;
    }
    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    resetSuccess.classList.remove('hidden');
    resetSuccess.focus();
}
resetPasswordSuccess();


//Register lock submit untill terms agreed
$("#Terms").change(function () {
    if (this.checked) {
        $("#Submit").prop('disabled', false).removeClass("button-disabled");
        $(".terms-error").toggleClass("hidden");
    } else {
        $("#Submit").prop('disabled', true).addClass("button-disabled");
    }
});


let newAddress = false;


$("#AddressNewForm form").on('submit input', function (e) {
    newAddress = true;
    validateForm($(this), e);
});

$("AddressNewForm form").on('input', function (e) {
    if (newAddress) {
        validateForm($(this), e);
    }

});

let registerUserd = false;
$("#RegisterForm").on('submit', function (e) {
    registerUserd = true;
    validateForm($(this), e);
});
$("#RegisterForm").on('input', function (e) {
    if (registerUserd) {
        validateForm($(this), e);
    }

});



function validateForm(form, e) {
    let formError = false;
    form.find('.required').each(function (e) {
        if (!$(this).val()) {
            $(this).closest('.form-field').find('.error-message').removeClass('hidden');
            $(this).closest('.form-field').find('.border-area').addClass('border-state-warning');
            formError = true;
        } else {
            $(this).closest('.form-field').find('.error-message').addClass('hidden');
            $(this).closest('.form-field').find('.border-area').removeClass('border-state-warning');
        }
    })
    if (formError) {
        e.preventDefault(); //prevent the default action
    }
}


window.addEventListener('load', function (event) {
  console.log("TEST123")
})

window.addEventListener('beforeunload', function (event) {
    var cookiesToClear = ['_shopify_essential'];
    cookiesToClear.forEach(function(cookieName) {
        document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
    });
});
